module.exports = __webpack_public_path__ + "static/noise-3799181c56629a94b69589159a4ea353.png";